module.exports = __webpack_public_path__ + "img/1576398576.cb49cd48.jpg";